<template>
  <div class="Suggestor" :class="inline ? 'Suggestor__inline' : ''">
    <div class="field has-addons has-addons-right">
      <input type="text" class="input" v-model="query" v-if="!item" />
      <button
        class="button is-small"
        v-if="!item"
        :class="loading ? 'is-loading' : ''"
        @click="add"
        :disabled="!q"
      >
        <i class="fas fa-plus"></i>
      </button>
    </div>
    <div class="Suggestions" v-show="haystack.length > 0 && q && !item">
      <div class="tags">
        <span
          class="Suggestion tag"
          v-for="s in haystack"
          @click="choose(s)"
          :key="s.id"
          >{{ s.name }}</span
        >
      </div>
    </div>
    <span
      v-if="item && current"
      class="Chosen tag"
      :class="inline ? 'is-light' : 'is-primary'"
    >
      <router-link v-show="!inline" :to="`/partner/edit/${current.uuid}`"
        ><i class="fas fa-edit"></i></router-link
      >&nbsp; {{ current.name }}
      <span class="delete is-small" @click="choose(null)"></span
    ></span>
  </div>
</template>
<script>
import { types as t } from "../../store/actions/partners";
import { partnerChangeKey } from "../../store/models/_helpers";

export default {
  name: "PartnerSuggestor",
  props: {
    item: {
      required: true
    },
    inline: {
      type: Boolean,
      default: false
    },
    full_contact: {},
  },
  data() {
    return {
      query: "",
      current: null,
      loading: false,
      haystack: []
    };
  },
  methods: {
    choose(a) {
      this.query = "";
      if (!a) {
        this.$emit("update", null);
        this.current = null;
        return;
      }
      this.current = a;
      if (!this.full_contact) {
        this.$emit("update", a.id);
      } else {
        this.$emit("update", a);
      }
    },
    async add() {
      this.loading = true;
      const newPartner = await this.$store.dispatch(t.ADD_PARTNER, {
        name: this.query.trim()
      });
      this.$emit("update", newPartner.id);
      this.$root.$emit(partnerChangeKey());
      this.query = "";
      this.loading = false;
    }
  },
  computed: {
    q() {
      return this.query.trim().toLowerCase();
    }
  },
  async mounted() {
    if (this.item) {
      this.current = await this.$store.dispatch(t.GET_PARTNER_BY_ID, {
        id: this.item
      });
    }
  },
  watch: {
    async q(val) {
      if (!val) {
        this.haystack = [];
        return;
      }
      this.haystack = await this.$store.dispatch(t.SEARCH_PARTNER, {
        query: val
      });
    },
    async item(val) {
      if (val)
        this.current = await this.$store.dispatch(t.GET_PARTNER_BY_ID, {
          id: val
        });
    }
  }
};
</script>
